module.exports = __webpack_public_path__ + "img/download-white.31a0d731.svg";